import React from "react";
import { CodeValidationResultWithIcon } from "./CodeValidationResultWithIcon";
import i18n from "../../../i18n/i18n";
import { Trans } from "react-i18next";
import { TestCaseResult } from "../../../data/ValidationResult";
import PassedIcon from "@mui/icons-material/CheckBox";
import FailedIcon from "@mui/icons-material/CheckBoxOutlineBlank";

interface TestCaseResultComponentProps {
    element: TestCaseResult;
}

export function TestCaseResultComponent(props: TestCaseResultComponentProps) {
    const { element } = props;

    const elementIcon = element.passed ? (
        <PassedIcon color="primary" />
    ) : (
        <FailedIcon color="primary" />
    );

    const hasErrors = element.errors.length > 0;

    return (
        <CodeValidationResultWithIcon icon={elementIcon}>
            <div>
                <b>{element.name}</b>
            </div>

            {hasErrors && <TestCaseResultErrors errors={element.errors} />}
            {!hasErrors && !element.passed && (
                <TestCaseResultValues
                    expectedValue={element.expectedValue}
                    actualValue={element.actualValue}
                />
            )}
        </CodeValidationResultWithIcon>
    );
}

function TestCaseResultErrors(props: { errors: string[] }) {
    const { errors } = props;

    const errorToDiv = (error: string, index: number) => (
        <div key={index}>
            <samp>{error}</samp>
        </div>
    );

    return (
        <div>
            {i18n.t("codeAssignmentPage:validation:executionError") + ":"}
            {errors.map(errorToDiv)}
        </div>
    );
}

function TestCaseResultValues(props: {
    expectedValue: string;
    actualValue: string;
}) {
    const { expectedValue, actualValue } = props;

    return (
        <div>
            <Trans
                i18nKey="codeAssignmentPage:validation:wrongValue"
                values={{
                    expectedValue: expectedValue,
                    actualValue: actualValue,
                }}
            >
                The expected value was <samp>{expectedValue}</samp> but the
                solution returned <samp>{actualValue}</samp>
            </Trans>
        </div>
    );
}
